import { render, staticRenderFns } from "./EditJournalEvent.vue?vue&type=template&id=2db81065&scoped=true&"
import script from "./EditJournalEvent.vue?vue&type=script&lang=js&"
export * from "./EditJournalEvent.vue?vue&type=script&lang=js&"
import style0 from "./EditJournalEvent.vue?vue&type=style&index=0&id=2db81065&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db81065",
  null
  
)

export default component.exports